import { useStaticQuery, graphql } from 'gatsby'
import { LinkI, VideoI, ImageI, PhoneI, GraphqlI, GraphqlNodeI } from '../types/common'

interface NavigationMenuI {
  menuTitle: string
  menuItems: LinkI[]
}
export interface NavMenuListI {
  navigationMenu?: NavigationMenuI[]
  directNavigationLinks?: LinkI[]
}

export interface SocialDataI {
  iconName: string
  label: string
  url: string
}

export interface WardrunaI {
  template: string
  isNavFixed: boolean
  title: string
  subtitle: string
  navigationMenu?: NavigationMenuI[]
  directNavigationLinks?: LinkI[]
  socialIcons: SocialDataI[]
  footer: Footer1I
}

export interface LandingPage1I {
  pageName: string
  isNavFixed: boolean
  featuredVideo: VideoI
}

export interface ContactUs1I {
  isNavFixed: boolean
  backgroundImage?: ImageI
  addressLabel?: string
  completeAddress?: string
  googleMapLink?: LinkI
  phone?: PhoneI
  email?: string
  thankYouSection: ThankYou1I
}

interface TeamMemberI {
  name: string
  photo: ImageI
  designation: string
  bio: string
}
export interface TeamInfo1I {
  title: string
  description: string
  teamMembers: TeamMemberI[]
}

export interface AboutUs1SectionI {
  title: string
  featuredImage: ImageI
  content: string
}
export interface AboutUs1I {
  isNavFixed: boolean
  teamInfo: TeamInfo1I
  aboutUsSections: AboutUs1SectionI[]
}

export interface ThankYou1I {
  successMessage: string
  thanksContent: string
  redirectLinks: LinkI[]
}

export interface Footer1I {
  title?: LinkI
  helperText?: string
}

// TODO: handle optional values and undefined case
interface PageDataJsonI {
  pageName?: string
  isNavFixed?: boolean
  template?: string
  title?: string
  subtitle?: string
  featuredVideo?: VideoI
  navigationMenu?: NavigationMenuI[]
  directNavigationLinks?: LinkI[]
  socialIcons?: SocialDataI[]
  footer?: Footer1I
  backgroundImage?: ImageI
  addressLabel?: string
  completeAddress?: string
  googleMapLink?: LinkI
  phone?: PhoneI
  email?: string
  thankYouSection?: ThankYou1I
  teamInfo?: TeamInfo1I
  aboutUsSections?: AboutUs1SectionI[]
}

const usePageDataJson = (): GraphqlI<PageDataJsonI> => {
  const { allPagesJson } = useStaticQuery(
    graphql`
      query {
        allPagesJson {
          edges {
            node {
              pageName
              isNavFixed
              template
              title
              subtitle
              featuredVideo {
                video
                thumbnail {
                  label
                  url
                }
              }
              navigationMenu {
                menuTitle
                menuItems {
                  label
                  url
                }
              }
              directNavigationLinks {
                label
                url
              }
              socialIcons {
                iconName
                label
                url
              }
              footer {
                title {
                  label
                  url
                }
                helperText
              }
              backgroundImage {
                label
                url
              }
              addressLabel
              completeAddress
              googleMapLink {
                label
                url
              }
              phone {
                countryCode
                number
              }
              email
              thankYouSection {
                successMessage
                thanksContent
                redirectLinks {
                  label
                  url
                }
              }
              teamInfo {
                title
                description
                teamMembers {
                  name
                  photo {
                    label
                    url
                  }
                  designation
                  bio
                }
              }
              aboutUsSections {
                title
                featuredImage {
                  label
                  url
                }
                content
              }
            }
          }
        }
      }
    `
  )
  return allPagesJson
}

export const getTemplateConfig = (templateName: string): GraphqlNodeI<PageDataJsonI> => {
  // TODO: what if below line does not find the templateName and returns undefined
  const filteredPageData = usePageDataJson().edges.find((pack) => pack.node.template === templateName)
  return filteredPageData as GraphqlNodeI<PageDataJsonI>
}

export const getPageConfig = (pageName: string): GraphqlNodeI<PageDataJsonI> => {
  // TODO: what if below line does not find the templateName and returns undefined
  const filteredPageData = usePageDataJson().edges.find((pack) => pack.node.pageName === pageName)
  return filteredPageData as GraphqlNodeI<PageDataJsonI>
}

export default usePageDataJson
